export default __webpack_public_path__ + "static/mediaculture-a8ced4af6f620e3e1fc4a67f3e5867ca.png";